<template>
  <div class="app-container">
    <div class="mx-2 mt-1">
      <!-- Navbar -->
      <nav class="bg-solimano py-4 px-2 rounded-3">
        <!-- Container wrapper -->
        <div class="d-flex align-items-center justify-content-center">
          <!-- Toggle button -->

          <!-- Collapsible wrapper -->

          <div class="me-auto ms-2 d-flex">
            <!-- Navbar brand -->
            <figure class="my-auto">
              <img
                class="mt-1"
                src="@/assets/Navbarhorizontal/Topas.png"
                height="60"
                width="200"
                alt="MDB Logo"
              />
            </figure>
          </div>
        </div>
      </nav>
      <!-- Navbar -->
    </div>
    <div class="container pt-1">
      <div v-if="!spinner" class="">
        <div class="border border-1 mx-2 px-2 mt-2 border-dark">
          <h5 class="mb-0 pb-0 mt-2">CONTROL DE ASISTENCIA</h5>
          <p class="mt-0 pt-0 mb-1">MARCACION</p>
        </div>

        <form action="" class="mx-5">
           <div class="form-group mt-2">
            <label style="font-weight: 700">DOC. IDENTIDAD :</label>
            <input
              type="number"
              required
              v-model="numeroDocumento"
              @blur="validarSubCentro"
              class="form-control py-2 mt-1"
              placeholder="ejemplo: 98765321"
            />
          </div>
          
          <div class="form-group mt-2" v-if="mostrarConcepto">
            <label style="font-weight: 700">CONCEPTO :</label>
            <select
              @change="parCorrelativo = $event.target.value"
              class="form-control mt-1 py-2"
              required
            >
              <option selected disabled value="">Seleccionar concepto</option>
              <option
                v-for="items in conceptosFiltrados"
                :key="items.id"
                :value="items.parCorrelativo"
              >
                {{ items.parDescripcion }}
              </option>
            </select>
          </div>

         
        </form>

        <!-- <div class="row mt-4 mx-1">
          <button
            class="btn btn-success mt-2 container py-auto h-25 col-12"
            @click="activarCamara"
          >
            <i class="bi bi-camera-video my-auto fs-3"></i
            ><label class="my-2 ms-2">ACTIVAR CAMARA</label>
          </button>

          <video
            v-if="videos"
            class="ms-1 col-12"
            ref="video"
            width="100%"
            height="300"
            autoplay
          ></video>
        </div> -->

        <!-- <div class="d-flex">
          <button
            v-if="videos"
            class="btn btn-dark h-25 py-auto w-100"
            @click="tomarFoto"
          >
            <i class="bi bi-camera fs-3 me-2"></i>
            <label class="my-2">TOMAR FOTO</label>
          </button>
          <img
            class="container mt-2"
            width="250"
            height="280"
            :src="fotoCapturada"
            alt="Foto"
            v-if="fotoCapturada && !videos"
          />
        </div> -->
      </div>

      <div v-if="!spinner">
        <div
          v-if="
            !['0201', '0202', '0203', '0204', '0205', '0103'].includes(
              subCentroTrabajador
            )"
          class="w-100 mt-3 text-center"
        >
          <label class="btn btn-primary">
            <i class="bi bi-upload"></i> Seleccionar Foto
            <input
              type="file"
              style="display: none"
              @change="handleFileChange"
              accept="image/*"
            />
          </label>
        </div>

        <div v-if="selectedImage" class="image-container text-center">
          <img
            :src="selectedImage"
            alt="Imagen seleccionada"
            class="selected-image"
          />
        </div>
      </div>

      <div class="color text-center py-0" v-if="spinner">
        <Spinner class="color py-0 my-0 w-100" />
      </div>

      <button
        @click="Registrar"
        class="btn btn-success py-3 container w-100 mt-3"
      >
        REGISTRAR ASISTENCIA
      </button>
    </div>

    <Footer class="mt-1" />
  </div>
</template>

<script>
import Footer from "@/components/ModSeleccion/Footer/Footer.vue";
import Spinner from "@/views/SpinnerCarga/SpinnerAsistencia.vue";
import Swal from "sweetalert2";
export default {
  components: {
    Footer,
    Spinner,
  },
  data() {
    return {
      video: null,
      fotoCapturada: null,
      streaming: false,
      videos: false,
      concepto: [],
      parCorrelativo: "",
      numeroDocumento: "",
      selectedImage: null,
      selectedFile: null,
      subCentroTrabajador: "",
      mostrarConcepto: true,
      idEmpresa: "",

      spinner: false,
    };
  },

  mounted() {
    // this.video = this.$refs.video;
    // this.activarCamara();

    this.axios.get(`ParametroData/Parametro/7704`).then((r) => {
      console.log(r.data);
      this.concepto = r.data;
    });
  },
  computed: {
    conceptosFiltrados() {
      // Se eliminan las opciones 2 y 3 (índices 1 y 2) solo si la empresa es la ID 4
      if (this.idEmpresa == 4) {
        return this.concepto.filter((_, index) => index !== 1 && index !== 2);
      }
      return this.concepto;
    }
  },
  methods: {
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
      console.log(event.target.files[0]);

      if (this.selectedFile) {
        // Crear una URL para la imagen seleccionada
        this.selectedImage = URL.createObjectURL(this.selectedFile);
      }
    },

    validarSubCentro() {
  return new Promise((resolve, reject) => {
    if (!this.numeroDocumento) {
      resolve(false);
      return;
    }

    this.axios
      .get(`Asistencia/ValidarSubCentro?nroDeDocumento=${this.numeroDocumento}`)
      .then((response) => {
        console.log("Respuesta de ValidarSubCentro:", response.data);

        // ✅ Asignar subcentro
        this.subCentroTrabajador = response.data.subCentro;
        this.idEmpresa = response.data.idEmpresa
        console.log("subCentroTrabajador actualizado:", this.subCentroTrabajador);

        // ✅ Actualizar visibilidad según subcentro
        const subcentrosSinFoto = ["0201", "0202", "0203", "0204", "0205", "0103", "0136", "0123", "0114", "0153", "0152", "0141", "0157", "0158", "0128", "0160", "0162", "0163", "0164", "0142", "0123", "0140","0145" ];
        const omitirFoto = subcentrosSinFoto.includes(this.subCentroTrabajador);

        this.mostrarInputFoto = !omitirFoto;
        this.mostrarConcepto = this.subCentroTrabajador !== "0103";

        // ✅ Opcional: limpiar valores si se ocultan
        // if (!this.mostrarInputFoto) {
        //   this.selectedFile = null;
        // }
        if (!this.mostrarConcepto) {
          this.parCorrelativo = "000";
        }

        resolve(true);
      })
      .catch((error) => {
        console.error("Error al validar subcentro:", error);
        this.subCentroTrabajador = "";
        reject(error);
      });
  });
},


    Registrar() {
      this.validarSubCentro().then((validado) => {
        if (!validado) return; // ⛔ Si falla la validación, detenemos el registro

        console.log(
          "SubCentro del trabajador en Registrar():",
          this.subCentroTrabajador
        );

        // Subcentros que no requieren foto
        const subcentrosSinFoto = [
          "0201",
          "0202",
          "0203",
          "0204",
          "0205",
          "0103",
        ];
        const omitirFoto = subcentrosSinFoto.includes(this.subCentroTrabajador);
        
        // Si el subcentro es 0103, entonces el correlativo debe ser '000'
        const correlativoFinal =
          this.subCentroTrabajador === "0103" ? "000" : this.parCorrelativo;
          
          console.log("assasf" , omitirFoto,this.selectedFile);
          
        // Validación de foto si es necesaria
        if (!omitirFoto && !this.selectedFile) {
          Swal.fire({
            icon: "error",
            title: "Debe seleccionar una foto",
          });
          return;
        }

        const formData = new FormData();
        formData.append("idConcepto", correlativoFinal);
        formData.append("nroDocumento", this.numeroDocumento);

        if (omitirFoto) {
          formData.append("Archivo", "1");
        } else {
          console.log("ajaja")
          formData.append("Archivo", this.selectedFile);
        }

        // 🔍 Inspeccionar FormData antes de enviarlo
        console.log("📤 Enviando datos en FormData:");
        formData.forEach((value, key) => {
          console.log(`${key}: ${value}`);
        });

        if (
          correlativoFinal !== "" &&
          this.numeroDocumento !== "" &&
          (omitirFoto || this.selectedFile)
        ) {
          this.spinner = true;
          this.axios
            .post("Trabajador/RegistrarAsistencia", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              this.spinner = false;
              this.numeroDocumento = "";
              this.parCorrelativo = "";
              this.selectedFile = null;
              this.selectedImage = null;
              Swal.fire({
                position: "top-center",
                icon: "success",
                title: `${response.data}`,
                showConfirmButton: true,
                timer: 4500,
              });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: `${error.response.data}`,
              });
              this.spinner = false;
            });
        } else {
          Swal.fire({
            icon: "error",
            title: "Verificar todos los campos",
          });
          this.spinner = false;
        }
      });
    },

    activarCamara() {
      this.videos = true;
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: "environment" }, insecure: true }) // Puedes ajustar las opciones según sea necesario
        .then((stream) => {
          // Enlazar la transmisión al elemento de video
          this.$refs.video.srcObject = stream;
          this.streaming = true;
        })
        .catch((error) => {
          console.error("Error al acceder a la cámara:", error);
        });
    },

    tomarFoto() {
      if (this.streaming) {
        this.videos = false;
        const canvas = document.createElement("canvas");
        canvas.width = this.$refs.video.videoWidth;
        canvas.height = this.$refs.video.videoHeight;
        const context = canvas.getContext("2d");
        context.drawImage(this.$refs.video, 0, 0, canvas.width, canvas.height);

        // Convertir la imagen a formato JPEG con calidad del 80%
        this.fotoCapturada = canvas.toDataURL("image/png", 0.8);
        console.log(this.fotoCapturada);
      }
    },

    base64ToBlob(base64) {
      const byteString = atob(base64.split(",")[1]);
      const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], { type: mimeString });
    },
  },
};
</script>

<style scoped>
.bg-solimano {
  background: #002c5d;
}

.image-container {
  margin-top: 20px;
}

.selected-image {
  max-width: 400px; /* Ajusta el tamaño según tus necesidades */
  max-height: 300px; /* Ajusta el tamaño según tus necesidades */
  border: 1px solid #ddd; /* Añade un borde opcional */
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-container > .container {
  flex: 1;
}

.color {
  background: #fffafa;
}
</style>
